
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650505669413",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4869",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M352 192.5H225c-40.2 0-73 32.7-73 73v574c0 40.2 32.7 73 73 73h574c40.2 0 73-32.7 73-73v-574c0-40.2-32.7-73-73-73H672v7.2c0 40.2-32.4 72.8-72.6 72.8H424.6c-40.1 0-72.6-32.6-72.6-72.8v-7.2z m347 300.3L511.4 708c-5 7.7-15 13.1-26.1 13.1-8.7 0-18.9-2.3-25.9-8.8l-111.2-94.7c-14.7-14.6-16.1-35.5-4.3-51.9 15.8-16.2 37.5-17.3 52.5-4.8l84.3 71.2L644 444.4c14.7-14.9 36.4-15.9 51.4-3.4 15 15.1 16.1 36.9 3.6 51.8zM392 172.5c0-33.1 26.6-60 59.9-60H572c33.1 0 59.9 26.6 59.9 60 0 33.1-26.6 60-59.9 60H451.9c-33.1 0-59.9-26.6-59.9-60z m0 0",
        "p-id": "4870",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  